<template>
  <div class="text-center my-5">
    <div class="spinner-border text-primary" role="status"></div>
    <h2 v-if="text" class="mt-3" v-html-safe="text"></h2>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    text: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #4b5863;
}
.spinner-border {
  width: 3rem;
  height: 3rem;
  border-width: 0.25rem;
  border-right-color: #dae2ea;
}
</style>
